import DataType from '@opsbase/lib-datatype/DataType';
import i18n from '@opsbase/lib-i18n';
import Palette from '@opsbase/lib-palette';
import useOrgTemplateDelete from '@opsbase/react-gql-hooks/orgtemplate/useOrgTemplateDelete';
import useSelection from '@opsbase/web-data-selection/useSelection';
import useSelectionActions from '@opsbase/web-data-selection/useSelectionActions';
import ConfirmDialog from '@opsbase/web-dialogs/ConfirmDialog';
import useParams from '@opsbase/web-nav/useParams';
import useNotificationActions from '@opsbase/web-notification/useNotificationActions';
import Text from '@opsbase/web-ui/Text';
import React, { useCallback, useMemo } from 'react';
export function OrgTemplateDeleteDialog() {
    const dataType = DataType.ORGTEMPLATE;
    const { id } = useParams();
    const { selecteds } = useSelection(dataType);
    const { clearSelection } = useSelectionActions(dataType);
    const { raise } = useNotificationActions();
    const ids = useMemo(() => (id === 'selected' ? selecteds.map(o => o.id) : [id]), [id, selecteds]);
    const deleteOrgTemplate = useOrgTemplateDelete();
    const handleAction = useCallback(() => raise(Promise.all(ids.map(theId => deleteOrgTemplate({ id: theId }))), i18n.t('template-delete-successful'), i18n.t('template-delete-failure')).then(clearSelection), [clearSelection, deleteOrgTemplate, ids, raise]);
    return (React.createElement(ConfirmDialog, { onConfirm: handleAction, agreeText: i18n.t('delete'), notAgreeText: i18n.t('cancel'), color: Palette.error },
        React.createElement(Text, null, i18n.t('confirm-template-delete', {
            count: ids.length,
        }))));
}
export default OrgTemplateDeleteDialog;
